import React from 'react';
import styles from './styles.module.scss';
import BreakpointContent from 'src/Components/BreakpointContent';
import Spinner from 'src/Components/Spinner';
import EmptyList from 'src/Components/EmptyList';
import { AppError } from 'src/redux/types';
import PageContent from 'src/Components/PageContent';
import PaginationControl_V2 from 'src/Components/PaginationControl_V2';
import { ITEMS_PER_PAGE } from 'src/Pages/CosmeticDetail/Components/ItemDetailCard/config';
import TableDesktopHeader from './Components/TableDesktopHeader';
import TableDesktop from 'src/Pages/CosmeticDetail/Components/ItemDetailCard/ItemDetail/StatsSection/SaleHistoryPanel/Components/TableDesktop';

const SaleHistoryPanel = ({
  data,
  invalidate,
  error,
  loading,
  totalItems,
  currentPage,
  onPageChange
}) => {
  const totalPages = totalItems ? Math.ceil(totalItems / ITEMS_PER_PAGE) : 1;

  const renderDesktop = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TableDesktopHeader, null), /*#__PURE__*/React.createElement(TableDesktop, {
      histories: data
    }));
  };

  const renderMobile = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.tableWrapperMobile
    }, /*#__PURE__*/React.createElement(TableDesktopHeader, null), /*#__PURE__*/React.createElement(TableDesktop, {
      histories: data
    }));
  };

  const renderContent = () => /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, !data.length && /*#__PURE__*/React.createElement(EmptyList, {
    title: "Sorry, no result found.",
    className: styles.empty
  }), !!data.length && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BreakpointContent, {
    renderPhone: renderMobile,
    renderTablet: renderMobile,
    renderDesktop: renderDesktop
  }), /*#__PURE__*/React.createElement(PaginationControl_V2, {
    className: styles.pagination,
    page: currentPage,
    totalPages: totalPages,
    onPageChange: onPageChange
  })));

  const renderLoading = () => {
    return /*#__PURE__*/React.createElement(Spinner, {
      className: styles.spinner
    });
  };

  const renderError = () => /*#__PURE__*/React.createElement(EmptyList, {
    title: "Sorry, something went wrong.",
    content: "Please try again.",
    className: styles.empty
  });

  return /*#__PURE__*/React.createElement(PageContent, {
    renderContent: renderContent,
    renderLoading: renderLoading,
    renderError: renderError,
    error: error !== AppError.NO_ERROR,
    loading: loading,
    invalidated: invalidate
  });
};

export default SaleHistoryPanel;